export const dataMenuHeaderNav = [
  {
    id: 1,
    designation: 'home',
    link: `<svg width="20" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 4L17 4" stroke="#171717" stroke-width="2" stroke-linecap="round"/>
<path d="M2 10L13 10" stroke="#171717" stroke-width="2" stroke-linecap="round"/>
<path d="M2 16L10 16" stroke="#171717" stroke-width="2" stroke-linecap="round"/>
</svg>




`,
  },

  {
    id: 2,
    designation: 'searhc',
    link: `<svg width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.58366 17.5C13.9559 17.5 17.5003 13.9556 17.5003 9.58333C17.5003 5.21108 13.9559 1.66667 9.58366 1.66667C5.2114 1.66667 1.66699 5.21108 1.66699 9.58333C1.66699 13.9556 5.2114 17.5 9.58366 17.5Z" stroke="#171717" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M18.3337 18.3333L16.667 16.6667" stroke="#171717" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>




`,
  },

  {
    id: 3,
    designation: 'backlEFTArrowIcon',
    link: `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="40" height="40" rx="20" fill="#938282" fill-opacity="0.05"/>
<path d="M20.2084 20.5V22.2334C20.2084 22.525 20.0584 22.8 19.8 22.95L17.5 24.2781" stroke="#625353" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M17.4999 28.3332H22.4999C25.8499 28.3332 26.4499 26.9915 26.6249 25.3582L27.2499 20.3582C27.4749 18.3248 26.8915 16.6665 23.3332 16.6665H16.6665C13.1082 16.6665 12.5249 18.3248 12.7499 20.3582L13.3749 25.3582C13.5499 26.9915 14.1499 28.3332 17.4999 28.3332Z" stroke="#625353" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16.25 16.3914V15.5831C16.25 13.7081 17.7583 11.8664 19.6333 11.6914C21.8667 11.4748 23.75 13.2331 23.75 15.4248V16.5748" stroke="#625353" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<circle cx="27" cy="17" r="4" fill="url(#paint0_linear_4541_8506)" stroke="#F9F9F9" stroke-width="1.5"/>
<defs>
<linearGradient id="paint0_linear_4541_8506" x1="23" y1="13" x2="31.4268" y2="13.2626" gradientUnits="userSpaceOnUse">
<stop stop-color="#FBAF01"/>
<stop offset="1" stop-color="#F89303"/>
</linearGradient>
</defs>
</svg>






`,
  },

  {
    id: 4,
    designation: 'backlEFTArrowIcon',
    link: `

<svg width="393" height="4" viewBox="0 0 393 4" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="393" height="4" fill="#938282" fill-opacity="0.05"/>
</svg>





`,
  },

  {
    id: 5,
    designation: 'backlEFTArrowIcon',
    link: `

<svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.00033 13.3332C10.2087 13.3332 12.8337 10.7082 12.8337 7.49984C12.8337 4.2915 10.2087 1.6665 7.00033 1.6665C3.79199 1.6665 1.16699 4.2915 1.16699 7.49984C1.16699 10.7082 3.79199 13.3332 7.00033 13.3332Z" stroke="#FF2D2D" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7 5.1665V8.08317" stroke="#FF2D2D" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M6.99707 9.8335H7.00231" stroke="#FF2D2D" stroke-linecap="round" stroke-linejoin="round"/>
</svg>





`,
  },

  {
    id: 6,
    designation: 'panierIcon',
    link: `

<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.99967 9.99984C12.3009 9.99984 14.1663 8.13436 14.1663 5.83317C14.1663 3.53198 12.3009 1.6665 9.99967 1.6665C7.69849 1.6665 5.83301 3.53198 5.83301 5.83317C5.83301 8.13436 7.69849 9.99984 9.99967 9.99984Z" stroke="#625353" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2.8418 18.3333C2.8418 15.1083 6.05013 12.5 10.0001 12.5C10.8001 12.5 11.5751 12.6083 12.3001 12.8083" stroke="#625353" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M18.3337 14.9998C18.3337 15.2665 18.3003 15.5248 18.2337 15.7748C18.1587 16.1082 18.0253 16.4332 17.8503 16.7165C17.2753 17.6832 16.217 18.3332 15.0003 18.3332C14.142 18.3332 13.367 18.0081 12.7837 17.4748C12.5337 17.2581 12.317 16.9998 12.1503 16.7165C11.842 16.2165 11.667 15.6248 11.667 14.9998C11.667 14.0998 12.0253 13.2749 12.6087 12.6749C13.217 12.0499 14.067 11.6665 15.0003 11.6665C15.9837 11.6665 16.8753 12.0915 17.4753 12.7749C18.0087 13.3665 18.3337 14.1498 18.3337 14.9998Z" stroke="#625353" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M16.2421 14.9834H13.7588" stroke="#625353" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15 13.7666V16.2583" stroke="#625353" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
</svg>






`,
  },
  {
    id: 7,
    designation: 'panierIcon',
    link: `

<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.63339 18.3337H14.3667C16.6667 18.3337 17.5834 16.9253 17.6917 15.2087L18.1251 8.32533C18.2417 6.52533 16.8084 5.00033 15.0001 5.00033C14.4917 5.00033 14.0251 4.70866 13.7917 4.25866L13.1917 3.05033C12.8084 2.29199 11.8084 1.66699 10.9584 1.66699H9.05006C8.19172 1.66699 7.19172 2.29199 6.80839 3.05033L6.20839 4.25866C5.97506 4.70866 5.50839 5.00033 5.00006 5.00033C3.19172 5.00033 1.75839 6.52533 1.87506 8.32533L2.30839 15.2087C2.40839 16.9253 3.33339 18.3337 5.63339 18.3337Z" stroke="#625353" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.75 6.66699H11.25" stroke="#625353" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M10.0001 14.9997C11.4917 14.9997 12.7084 13.783 12.7084 12.2913C12.7084 10.7997 11.4917 9.58301 10.0001 9.58301C8.50841 9.58301 7.29175 10.7997 7.29175 12.2913C7.29175 13.783 8.50841 14.9997 10.0001 14.9997Z" stroke="#625353" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`,
  },

  {
    id: 8,
    designation: 'timesSearch',
    link: `

<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_4395_6309)">
<circle cx="10.0001" cy="10.0003" r="8.33333" stroke="#938282" stroke-width="2"/>
<path d="M12.0834 7.91701L7.91675 12.0837M7.91673 7.91699L12.0834 12.0836" stroke="#938282" stroke-width="2" stroke-linecap="round"/>
</g>
<defs>
<clipPath id="clip0_4395_6309">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg>

`,
  },

  {
    id: 9,
    designation: 'like',
    link: `

<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.5167 17.3413C10.2334 17.4413 9.76675 17.4413 9.48342 17.3413C7.06675 16.5163 1.66675 13.0747 1.66675 7.24134C1.66675 4.66634 3.74175 2.58301 6.30008 2.58301C7.81675 2.58301 9.15842 3.31634 10.0001 4.44967C10.8417 3.31634 12.1917 2.58301 13.7001 2.58301C16.2584 2.58301 18.3334 4.66634 18.3334 7.24134C18.3334 13.0747 12.9334 16.5163 10.5167 17.3413Z" fill="#938282"/>
</svg>


`,
  },
  {
    id: 10,
    designation: 'like',
    link: `

<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="5" cy="10" r="1" fill="#625353" stroke="#625353"/>
<circle cx="10" cy="10" r="1" fill="#625353" stroke="#625353"/>
<circle cx="15" cy="10" r="1" fill="#625353" stroke="#625353"/>
</svg>



`,
  },
];
